import { HostingDisplayName } from '@atlassian/mpac-types';
import { AtlassianProductHostingTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import { ALL_SALES, APP } from "./SalesReports.constants";

const getSalesReportHeader = () => ({
  cells: [{
    key: 'string',
    content: APP,
    isSortable: true,
    style: {
      minWidth: '250px'
    }
  }, {
    key: 'number',
    content: HostingDisplayName[AtlassianProductHostingTypeValues.Cloud],
    isSortable: true
  }, {
    key: 'number',
    content: HostingDisplayName[AtlassianProductHostingTypeValues.Server],
    isSortable: true
  }, {
    key: 'number',
    content: HostingDisplayName[AtlassianProductHostingTypeValues.DataCenter],
    isSortable: true
  }, {
    key: 'number',
    content: ALL_SALES,
    isSortable: true
  }]
});

export default getSalesReportHeader;